import React from "react";
import { Link } from "react-router-dom";
import SiteShell from "../components/layout/SiteShell";
import ContentPageLayout from "../components/content/ContentPageLayout";
import SEO from "../components/seo/SEO";
import ContactForm from "../components/ContactForm";
import ContactBusinessCard from "../components/contact/ContactBusinessCard";

export default function ContactPage() {
  return (
    <SiteShell theme="dark">
      <SEO
        title="Contact MossMatrix"
        description="Contact MossMatrix at info@mossmatrix.com for order questions, press, or wholesale notes. Guest checkout, no login required."
        path="/contact"
      />
      <ContentPageLayout
        eyebrow="Contact"
        title="Say hello. We read everything."
        subtitle="Orders, press, collaborations, or feedback. We’re a small UK team: detail helps, and a real human replies."
      >
        <div className="grid lg:grid-cols-[minmax(0,26rem)_minmax(0,1fr)] xl:grid-cols-[minmax(0,30rem)_minmax(0,1fr)] gap-10 lg:gap-12 xl:gap-16 items-start">
          <div className="lg:sticky lg:top-28 order-1 justify-self-center lg:justify-self-stretch w-full">
            <ContactBusinessCard />
          </div>

          <div className="order-2 min-w-0">
            <ContactForm />

            <p className="mt-6 text-xs text-botanical/65 leading-relaxed border-t border-cream pt-6 max-w-xl">
              <strong className="text-forest font-medium">UK orders only at this stage.</strong> Shipping within the
              United Kingdom only. International shipping is not currently available.
            </p>
            <p className="mt-4 text-sm text-botanical/80 max-w-xl">
              <Link to="/faq" className="underline hover:text-forest">
                Read the FAQ
              </Link>
              , or open the MossMatrix helper chat (bottom corner on larger screens, above the mobile nav on small
              screens) for quick answers on sea moss, blends, and delivery.
            </p>
          </div>
        </div>
      </ContentPageLayout>
    </SiteShell>
  );
}
